import React, { useState } from 'react';
import { Modal } from '@cimpress/react-components';
import Countdown from 'react-countdown';
const RedirectToContractManagerV2 = function RedirectToContractManagerV2({
  isItHomePage,
  enableCloseButton,
  stayOnContractV1,
  seller,
  doesBusinessMovedToV2
}) {
  const [show, setShow] = useState(true);
  const renderer = ({ seconds, completed }) => {
    if (completed) {
      // Render a completed state
      window.location.href = process.env.REACT_APP_CONTRACT_MANAGER_V2;
      return null;
    } else {
      // Render a countdown
      return <span style={{ color: 'blue', fontSize: '16px' }}>{seconds}</span>;
    }
  };

  const goToContractV2 = () => {
    window.location.href = process.env.REACT_APP_CONTRACT_MANAGER_V2;
  };

  const businessNotMovedToV2 = () => {
    const message = (
      <div>
        <p>
          {' '}
          A new version of Contract Manager is available{' '}
          <a href={process.env.REACT_APP_CONTRACT_MANAGER_V2} onClick={() => setShow(false)}>
            here
          </a>{' '}
          In this version you will be able to
          <ul>
            <li>to view Pricing Term for the sellers who's Pricing is in v1 or</li>
            <li>to view Product agreements if the Pricing is in v2.</li>
          </ul>
        </p>
        <p>
          {' '}
          If you are buying from a seller whose pricing is in Pricing Manager v2, you only have to agree on the
          following terms of your relationship.
          <ul>
            <li>Notification days for Price change</li>
            <li>Notification days for Product Archiving</li>
            <li>How shipping is settled</li>
          </ul>
        </p>
        <p>
          You no longer need to approve contracts or add/remove products into contracts etc. Further Documentation
          available{' '}
          <a
            href="https://cimpress-support.atlassian.net/wiki/spaces/CI/pages/536379580/Contract+Manager+2.0"
            onClick={() => setShow(false)}>
            here
          </a>{' '}
        </p>
      </div>
    );
    return message;
  };

  return (
    <Modal
      show={show}
      className="foobar"
      closeButton={false}
      style={{ height: 100, width: doesBusinessMovedToV2 === false ? 600 : 600 }}
      bsStyle="info"
      footer={
        <div>
          <button
            style={{ display: enableCloseButton || doesBusinessMovedToV2 === false ? 'visible' : 'none' }}
            className="btn btn-default"
            onClick={stayOnContractV1}>
            Stay in Contract Manager v1
          </button>
          <button className="btn btn-default" onClick={goToContractV2}>
            Go to Contract Manager v2
          </button>
        </div>
      }>
      {doesBusinessMovedToV2 === false ? (
        businessNotMovedToV2()
      ) : (
        <div>
          <p>
            {' '}
            {isItHomePage && doesBusinessMovedToV2
              ? 'Your business is migrated to Pricing Arch V2.'
              : `The seller ${seller.name} is migrated to Pricing Arch V2.`}{' '}
          </p>
          <p>
            {' '}
            Redirecting you to new Contract Manager, which enables managing relationships with other businesses simple
            and effective.
          </p>
          <p>
            {' '}
            Click{' '}
            <a href={process.env.REACT_APP_CONTRACT_MANAGER_V2} onClick={() => setShow(false)}>
              {' '}
              here{' '}
            </a>{' '}
            to{' '}
            <a href={process.env.REACT_APP_CONTRACT_MANAGER_V2} onClick={() => setShow(false)}>
              Contract Manager V2
            </a>
          </p>
          <p>
            Redirecting to Contract Manager V2... <Countdown date={Date.now() + 10000} renderer={renderer} />
          </p>
        </div>
      )}
    </Modal>
  );
};

export { RedirectToContractManagerV2 };
